"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Image = _interopRequireDefault(require("../Image"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Inspiration = _interopRequireDefault(require("@deosite/ui-entities/Inspiration"));
var __jsx = _react["default"].createElement;
var InspirationHeader = function InspirationHeader(props) {
  var inspiration = props.inspiration,
    _onClick = props.onClick,
    button = props.button;
  var influencerData = inspiration.influencerData,
    title = inspiration.title;
  var image = influencerData.image,
    name = influencerData.name,
    url = influencerData.url,
    username = influencerData.username;
  var translations = {
    curatedBy: (0, _langLibrary["default"])("Curated by"),
    shopItemsBelow: (0, _langLibrary["default"])("Shop items below"),
    from: (0, _langLibrary["default"])("from")
  };
  var inspirationHeaderButton = /*#__PURE__*/_react["default"].cloneElement(button, {
    onClick: function onClick() {
      return _onClick;
    }
  }, translations.shopItemsBelow);
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      mt: "s8",
      mb: "s8",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      mb: "s7",
      font: "xl",
      textAlign: "center",
      width: "80%"
    }
  }, title), __jsx(_Box["default"], {
    sx: {
      width: 80,
      height: 80,
      borderRadius: 80,
      overflow: "hidden"
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1
    },
    image: image
  })), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s"
    }
  }, translations.curatedBy), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      font: "s",
      mb: "s8"
    }
  }, __jsx(_Box["default"], null, name), "\xA0", translations.from, "\xA0", __jsx(_Box["default"], {
    sx: {
      font: "s_italic"
    }
  }, __jsx(_LinkRaw["default"], {
    href: url,
    target: "_blank",
    title: name
  }, " @" + username))), __jsx(_Box["default"], {
    sx: {
      display: ["block", null, "none"]
    }
  }, inspirationHeaderButton));
};
var _default = InspirationHeader;
exports["default"] = _default;